import { ECOSYSTEM_MALL_MENU_IDS } from '@/constants/ecosystemMall'
import { SUBSCRIPTION_BILLING_MENU_IDS } from '@/constants/sidebarMenuIdSsot.mjs'

function menuNodeNumericId (n) {
  if (!n || n.id == null) return null
  const v = Number(n.id)
  return Number.isFinite(v) ? v : null
}

function findNodeById (nodes, id, acc = null) {
  if (!Array.isArray(nodes)) return acc
  for (const n of nodes) {
    if (!n) continue
    if (menuNodeNumericId(n) === Number(id)) return n
    const hit = findNodeById(n.menuList, id, acc)
    if (hit) return hit
  }
  return acc
}

function navFlatHasMenuId (navFlat, id) {
  if (!Array.isArray(navFlat)) return false
  return navFlat.some((n) => n && Number(n.id) === Number(id))
}

/**
 * 价目表／计费促销／公司收款：DB 主挂「生态商城 → 定价与收款」991123（patch 413／493）。
 * 本函数把 HQ 收款页镜像进同一夹（幂等）；根＝平台下生态商城 990420。
 */
export function injectMallPricingCollectMirror (sidebarTree, navFlat) {
  if (!Array.isArray(sidebarTree)) return sidebarTree
  const priceBookId = ECOSYSTEM_MALL_MENU_IDS.priceBook
  if (!navFlatHasMenuId(navFlat, priceBookId)) return sidebarTree

  function findEcoMallNode (nodes) {
    if (!Array.isArray(nodes)) return null
    for (const n of nodes) {
      if (!n) continue
      if (
        menuNodeNumericId(n) === ECOSYSTEM_MALL_MENU_IDS.group ||
        n.enName === 'ecosystemMallGroup' ||
        menuNodeNumericId(n) === 990420
      ) {
        return n
      }
      const hit = findEcoMallNode(n.menuList)
      if (hit) return hit
    }
    return null
  }
  const mall = findEcoMallNode(sidebarTree)
  if (!mall) return sidebarTree

  if (!Array.isArray(mall.menuList)) mall.menuList = []

  let folder = mall.menuList.find(
    (n) => menuNodeNumericId(n) === SUBSCRIPTION_BILLING_MENU_IDS.mallPricingCollectFolder
  )
  if (!folder) {
    folder = {
      id: SUBSCRIPTION_BILLING_MENU_IDS.mallPricingCollectFolder,
      name: '定价与收款',
      enName: 'mallPricingCollectFolder',
      icon: 'soc-mall-price-book',
      type: 0,
      menuList: []
    }
    mall.menuList.push(folder)
  }
  if (!Array.isArray(folder.menuList)) folder.menuList = []

  const src = findNodeById(sidebarTree, priceBookId)
  if (src && !folder.menuList.some((n) => menuNodeNumericId(n) === priceBookId)) {
    folder.menuList.push(Object.assign({}, src, { parentId: String(folder.id) }))
  }

  const companyPayId = ECOSYSTEM_MALL_MENU_IDS.companyPay
  if (navFlatHasMenuId(navFlat, companyPayId)) {
    const paySrc = findNodeById(sidebarTree, companyPayId)
    if (paySrc && !folder.menuList.some((n) => menuNodeNumericId(n) === companyPayId)) {
      folder.menuList.push(Object.assign({}, paySrc, { parentId: String(folder.id) }))
    }
  }

  return sidebarTree
}

export default injectMallPricingCollectMirror



// WEBPACK FOOTER //
// ./src/utils/mallPricingCollectMenuAlign.js